import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

const predefinedAllergies = [
  { id: 'gluten', icon: '🌾' },
  { id: 'crustaceans', icon: '🦐' },
  { id: 'eggs', icon: '🥚' },
  { id: 'fish', icon: '🐟' },
  { id: 'peanuts', icon: '🥜' },
  { id: 'soybeans', icon: '🌱' },
  { id: 'milk', icon: '🥛' },
  { id: 'nuts', icon: '🌰' },
  { id: 'celery', icon: '🥬' },
  { id: 'mustard', icon: '🌾' },
  { id: 'sesame', icon: '⚪' },
  { id: 'sulphites', icon: '💨' },
  { id: 'lupin', icon: '🌼' },
  { id: 'molluscs', icon: '🐚' },
];

const AccompanyingGuest = ({ guest, index, onChange, onRemove }) => {
  const { t } = useTranslation();
  const { allergies = [] } = guest;

 
  const toggleAllergy = useCallback(
    (allergy) => {
      const updatedAllergies = allergies.includes(allergy)
        ? allergies.filter((a) => a !== allergy)
        : [...allergies, allergy];
      onChange(index, 'allergies', updatedAllergies);
    },
    [allergies, index, onChange]
  );

  return (
    <div className="border border-gray-300 p-4 rounded-lg space-y-4">
      <h4 className="font-bold text-gray-800">
        {t('accompanyingGuest.guestNumber', { index: index + 1 })}
      </h4>
      <input
        type="text"
        placeholder={t('accompanyingGuest.firstName')}
        value={guest.firstName}
        onChange={(e) => onChange(index, 'firstName', e.target.value)}
        className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-royal-gold-500"
        required
      />
      <input
        type="text"
        placeholder={t('accompanyingGuest.lastName')}
        value={guest.lastName}
        onChange={(e) => onChange(index, 'lastName', e.target.value)}
        className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-royal-gold-500"
        required
      />
      <select
        value={guest.menuOption}
        onChange={(e) => onChange(index, 'menuOption', e.target.value)}
        className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-royal-gold-500"
        required
      >
        <option value="normal">Normal</option>
        <option value="vegan">Vegano</option>
        <option value="child">Infantil</option>
      </select>
      <div className="space-y-2">
        <h5 className="font-medium text-gray-700">
          {t('guestForm.allergies')}
        </h5>
        {predefinedAllergies.map((allergy) => (
          <label key={allergy.id} className="flex items-center space-x-2">
            <input
              type="checkbox"
              checked={allergies.includes(allergy.id)}
              onChange={() => toggleAllergy(allergy.id)}
              className="h-5 w-5 text-royal-gold-600"
            />
            <span>
              {allergy.icon} {t(`guestForm.allergyList.${allergy.id}`)}
            </span>
          </label>
        ))}
        <input
          type="text"
          placeholder={t('accompanyingGuest.customAllergyPlaceholder')}
          value={guest.customAllergy || ''}
          onChange={(e) => onChange(index, 'customAllergy', e.target.value)}
          className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-royal-gold-500"
        />
      </div>
      <button
        type="button"
        onClick={() => onRemove(index)}
        className=" w-full justify-center bg-red-500 text-white px-4 py-2 rounded-lg hover:bg-red-900"
      >
        {t('accompanyingGuest.remove')}
      </button>
    </div>
  );
};

export default AccompanyingGuest;